var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import Drawer from '@mui/material/Drawer';
import { styled } from '@mui/material/styles';
const StyledDrawer = styled(Drawer) `
    width: 400px;
    flex-shrink: 0;

    & .MuiDrawer-paper {
        background-color: #f7f7f7;
        width: 400px;
    }
`;
export const Sidebar = (props) => {
    const drawerProps = __rest(props, []);
    return _jsx(StyledDrawer, Object.assign({ variant: 'persistent', anchor: 'left' }, drawerProps));
};
